import React from 'react';

interface FactsTableProps {
  entries: [string, string | React.ReactNode][];
}

export const FactsTable: React.FC<FactsTableProps> = ({ entries }) => {
  return (
    <div className="grid grid-cols-[auto,1fr] items-center gap-y-16 gap-x-64 items-baseline">
      {entries.map(([key, value], idx) => (
        // eslint-disable-next-line react/no-array-index-key
        <React.Fragment key={idx}>
          <div className="typo-text-14--bold text-faded">{key}</div>
          {typeof value === 'string' ? <div className="typo-text-14 text-faded">{value}</div> : value}
        </React.Fragment>
      ))}
    </div>
  );
};
